<template>
    <div class="cargoInfo">
    <el-form :model="dataForm" ref="dataForm" label-position="top"  class="dataForm">
      <div class="coupons" v-if="(optionlist && optionlist.length) || nowMoney || dataForm.costEstimate && dataForm.costEstimate.isUseAcc">
          <el-form-item label="优惠券"  prop="coupons" v-if="optionlist && optionlist.length">
              <el-select  @change="changeCoupon" :disabled="!optionlist || !optionlist.length" class="ab-select"  v-model="formData.couponId"  placeholder="请选择优惠券">
                    <el-option
                        v-for="(item,keys) in optionlist"
                        :key="keys"
                        :disabled="item.isOccupy"
                        :label="item.label"
                        :value="item.id">
                    </el-option>
              </el-select>
          </el-form-item>
          
          <el-form-item label="账号余额"  prop="balance"  v-if="nowMoney || dataForm.costEstimate && dataForm.costEstimate.isUseAcc">
              <el-select  :disabled="(nowMoney == 0 && !formData.accountUseAmount)" class="ab-select"   @change="updatedInfo" v-model="formData.isUseAcc" placeholder="请选择">
                    <el-option
                        v-for="(item,keys) in [{label: '不使用', value: false}, {label: '使用', value: true}]"
                        :key="keys"
                        :label="item.label"
                        :value="item.value">
                    </el-option>              
              </el-select>
          </el-form-item>
          
      </div>
    </el-form>
    </div>
</template>

<script>
export default {
    data () {
        return {
            optionlist: [],
            nowMoney: 0,
            formData: {

            }
        }
    },
    props: {
        dataForm: {
            type: Object
        },
    },
    watch : {
        "dataForm.number": function (id) {
            if (id) {
                this.init()
            }
        },
        "dataForm.costEstimate": {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.formData = newVal
                    this.getCouponEntry()
                }
            },
            deep : true
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.$get("/oms/principalIntegral/get").then(({data}) => {
              this.formData = _.cloneDeep(this.dataForm.costEstimate) || {}
              if(data.result) {
                this.nowMoney = data.result.nowMoney || 0
              }
            //   if (this.nowMoney != 0) {
            //     this.formData.isUseAcc = true
            //   }
            })
            
        },
        getCouponEntry () {
            this.$post('/oms/client/couponEntry/list', {
                data: {
                    bizType: this.dataForm.bizType,
                    checkValidStartTime: true,
                    sortFirstId: this.dataForm.costEstimate.couponId,
                    sourceBillNumber: this.dataForm.number,
                     isReceived: 1
                },
                pageNum: 1,
                pageSize: 99
            }).then(res => {
                let data = res.data
                if (data.code == 'C0000') {
                    if (data.result.list.length > 0) {
                        data.result.list.map(e => {
                            e.label = e.amount + '元现金劵'
                            if (e.couponId == e.id) {

                            }
                        })
                        this.optionlist = data.result.list
                        this.optionlist.push({label: '不使用', amount: 0, id: 0})
                        if (!this.dataForm.id) {
                            //取出到期日期最早的优惠券
                            let obj = this.optionlist[0]
                            for (let index = 0; index < this.optionlist.length - 1; index++) {
                                const element = this.optionlist[index]
                                if(new Date(element.validEndTime).getTime() < new Date(obj.validEndTime).getTime()) {
                                    obj = element
                                }
                            }
                            this.formData.couponId = obj.id
                            this.formData.couponAmount = obj.amount
                            this.$emit('updatedInfo', this.formData)
                        }
                        this.formData.isUseAcc = this.dataForm.costEstimate.isUseAcc
                    } else {
                        this.formData.couponId = ''
                        this.formData.couponAmount = ''
                        this.formData.couponUseAmount = ''
                        this.formData.couponUseAmountShow = ''
                        this.$emit('updatedInfo', this.formData)
                    }
                }
            })
        },
        changeCoupon (id) {
            if (!id) {
                this.formData.couponAmount = ''
            }else{
                this.optionlist.map(e => {
                    if (id == e.id) {
                        this.formData.couponAmount = e.amount
                    }
                })
            }
            this.$emit('updatedInfo', this.formData)
        },
        updatedInfo (v) {
            this.$emit('updatedInfo', this.formData)
        }
    }
}
</script>

<style lang="scss">
.cargoInfo {
    .coupons {
        .ab-select{
            width: 400px;
            .select-trigger {
                height: 45px;
                .el-input{
                    height: 100%;
                }
            }
        }
    }
}
</style>